
const digest = 'f8ffe1daf1f2377f160e325aefed6d455c97e2933f5fcadffd661ffd9d34a4c7';
const classes = {"wrapper":"_wrapper_ttk7b_1","inline":"_inline_ttk7b_8","suffix":"_suffix_ttk7b_14","part":"_part_ttk7b_17","timePickerWrapper":"_timePickerWrapper_ttk7b_20","daysWrapper":"_daysWrapper_ttk7b_23"};
const css = `._wrapper_ttk7b_1 {
  background-color: #ffffff;
  border: 1px solid #eaedf3;
  font-family: Rubik, sans-serif;
  height: 100%;
  overflow-y: auto;
}
._wrapper_ttk7b_1 ._inline_ttk7b_8 {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}
._wrapper_ttk7b_1 ._suffix_ttk7b_14 {
  font-size: 14px;
}
._wrapper_ttk7b_1 ._part_ttk7b_17 {
  margin-bottom: 20px;
}
._wrapper_ttk7b_1 ._timePickerWrapper_ttk7b_20 {
  width: 100px;
}
._wrapper_ttk7b_1 ._daysWrapper_ttk7b_23 {
  width: 60px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  